const getBrowserInfo = () => {
  {
    const colorDepth = window.screen.colorDepth;
    const javaEnabled = window.navigator.javaEnabled ? window.navigator.javaEnabled() : false;
    const screenHeight = window.screen.height;
    const screenWidth = window.screen.width;
    const userAgent = window.navigator.userAgent || "";
    const language = window.navigator.language || "en";
    const currentData = /* @__PURE__ */ new Date();
    const timeZoneOffset = currentData.getTimezoneOffset();
    return {
      acceptHeader: "*/*",
      colorDepth,
      language,
      javaEnabled,
      screenHeight,
      screenWidth,
      userAgent,
      timeZoneOffset,
      javaScriptEnabled: true
    };
  }
};
export {
  getBrowserInfo
};
//# sourceMappingURL=get-browser-info.js.map
